import { render, staticRenderFns } from "./FooterAppTop.vue?vue&type=template&id=08e84b86&scoped=true&"
import script from "./FooterAppTop.vue?vue&type=script&lang=js&"
export * from "./FooterAppTop.vue?vue&type=script&lang=js&"
import style0 from "./FooterAppTop.vue?vue&type=style&index=0&id=08e84b86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../nodevenv/public_html/de.jeanmarcphilippe.com/shop.digipart.fr/16/lib/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e84b86",
  null
  
)

export default component.exports